export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-clock-771aa7d3bde90982334cbf56ec0c2264.svg";